export default function (value) {
  return value === undefined || value === null;
}
